import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AppStore from '../../stores/AppStore';
import _get from 'lodash/get';
import * as FPT from '../../utility/fpt';
import { Modal } from '@paypalcorp/pp-react';

import { localsMessages } from '../../utility/getTemplateData';
let threeDSText = localsMessages('common/threeDSecure');

class ThreeDSIframe extends Component {
  shouldComponentUpdate(nextProps, nextState) {
    return false;
  }

  componentDidMount() {
    this.addEventListener();
    this.submitForm();

    const threeDSRespDuration = {
      challenge_start_time: new Date().getTime(),
    };
    FPT.add3DSRespDuration(
      threeDSRespDuration,
      window.fpti.pgrp,
      window.fpti.page
    );
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.handleIframeMessage);
  }

  addEventListener = () => {
    window.addEventListener('message', this.handleIframeMessage);
  };

  handleIframeMessage = (event) => {
    const source = _get(event, 'data.source');
    const confirmationStatus = _get(event, 'data.confirmationStatus');
    const error = _get(event, 'data.err');

    if (source !== 'paypal') {
      return;
    }

    FPT.add3DSChallengeStatus(confirmationStatus);
    FPT.trackError(error);
    const threeDSRespDuration = {
      challenge_end_time: new Date().getTime(),
    };
    FPT.add3DSRespDuration(
      threeDSRespDuration,
      window.fpti.pgrp,
      window.fpti.page
    );

    this.props.onStepUpAuthComplete({
      confirmationStatus,
      error,
    });
    this.props.hideModal();
  };

  setFormRef = (element) => {
    this.formRef = element;
  };

  submitForm = () => {
    setTimeout(() => {
      if (this.formRef) {
        this.formRef.submit();
      }
    }, 100);
  };

  getModalBody = () => {
    const contingency = AppStore.getThreeDSContingency() || {};

    const { threeDS2Contingency } = contingency;

    const redirectLink = _get(threeDS2Contingency, '3d_secure_redirect_link');
    const jwt = _get(threeDS2Contingency, 'jwt');
    const fundingOptions = AppStore.getFundingOptions();
    const md = _get(fundingOptions, 'id', '');
    const redirectMethod = _get(
      threeDS2Contingency,
      'cardinal_redirect_method'
    );

    let requestText = _get(
      threeDSText,
      'requestText',
      'Enter requested information to confirm your card'
    );

    return (
      <div className="modal-body">
        <div className="text-center">
          <div className="container">
            <img src="https://www.paypalobjects.com/webstatic/icon/favicon.ico" />
          </div>
          <div>
            <h3>{requestText}</h3>
          </div>
          <iframe
            title="ThreeDSIframe"
            name="stepUp"
            id="stepUp"
            style={{
              width: '500px',
              height: '640px',
            }}
            frameBorder="0"
          >
            <form
              ref={this.setFormRef}
              name="stepUpForm"
              id="stepUpForm"
              target="stepUp"
              method={redirectMethod}
              action={redirectLink}
            >
              <input type="hidden" name="JWT" value={jwt} />
              <input type="hidden" name="MD" value={md} />
            </form>
          </iframe>
        </div>
      </div>
    );
  };

  render() {
    return (
      <Modal
        className="three-ds2-iframe-overpanel"
        overpanel
        title=""
        isOpen={this.props.isOpen}
        onClose={this.props.hideModal}
        hideLogo
        closeOnBackgroundClick={false}
      >
        {this.getModalBody()}
      </Modal>
    );
  }
}

ThreeDSIframe.propTypes = {
  onStepUpAuthComplete: PropTypes.func,
  icon: PropTypes.string,
  hideModal: PropTypes.func,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
};
export default ThreeDSIframe;
